import type { Messages } from "../types";

export const en: Messages = {
  "ui.start.title": "Waterra",
  "ui.start.prompt": "Pick an animal",
  "ui.start.aria-label": "Pick an animal",
  "ui.start.settings.heading": "Settings",
  "ui.start.sound.on": "Sound: On",
  "ui.start.sound.off": "Sound: Off",
  "ui.start.tutorial.replay": "Replay tutorial",
  "ui.start.tutorial.queued": "Tutorial queued",
  "ui.start.play": "Play",
  "ui.start.play.aria": "Play",
  "ui.start.play-as.aria": "Play as {animal}",
  "ui.start.version.aria": "Build version {label}",
  "ui.pause.aria-label": "Game paused",
  "ui.pause.title": "Paused",
  "ui.pause.resume": "Resume",
  "ui.pause.restart": "Restart",
  "ui.pause.select": "Back to animal selection",
  "ui.pause-button.aria-label": "Pause",
  "ui.objective.eat-fish.label": "Eat {target} fish",
  "ui.objective.completed": "Objective complete!",
  "ui.score.label": "Score",
  "ui.orientation.message": "Rotate your device to landscape",
  "ui.action.ascend": "Ascend",
  "ui.action.descend": "Descend",
  "ui.camera.free.label": "Camera: Free",
  "ui.camera.free.aria": "Switch to chase camera",
  "ui.camera.chase.label": "Camera: Chase",
  "ui.camera.chase.aria": "Switch to free camera",
  "ui.mode.exploration.label": "Mode: Exploration",
  "ui.mode.exploration.aria": "Switch to survival mode",
  "ui.mode.survival.label": "Mode: Survival",
  "ui.mode.survival.aria": "Switch to exploration mode",
  "ui.tutorial.aria-label": "Tutorial",
  "ui.tutorial.step.counter": "Step {current} of {total}",
  "ui.tutorial.step.move.title": "Move",
  "ui.tutorial.step.move.body":
    "Drag the joystick on the left to swim. On a keyboard, use WASD or the arrow keys.",
  "ui.tutorial.step.action.title": "Act",
  "ui.tutorial.step.action.body":
    "Tap a nearby fish to catch it, or a predator to scare it off. Use the up and down arrows to control your depth in the water.",
  "ui.tutorial.step.objective.title": "Objective",
  "ui.tutorial.step.objective.body":
    "Follow the goal at the top of the screen. Your score climbs with every fish you eat.",
  "ui.tutorial.next": "Next",
  "ui.tutorial.done": "Got it",
  "ui.tutorial.skip": "Skip",
  "animal.seal": "Seal",
  "animal.penguin": "Penguin",
  "animal.fish": "Fish",
};
